import React from 'react';
import PropTypes from 'prop-types';

export default function Area(props) {
  return (
    <svg width={props.width} height={props.width} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1L15.3 4.3L14.3571 5.24286L18.7571 9.64285L19.6999 8.70001L23 12L19.6999 15.3L18.7571 14.3571L14.3571 18.7571L15.3 19.7L12 23L8.69997 19.7L9.64289 18.7571L5.24291 14.3571L4.3 15.3L1 12L4.3 8.70001L5.2429 9.64291L9.64289 5.24292L8.69997 4.3L12 1ZM12.9429 17.3429L12 16.4L11.0571 17.3429L6.65713 12.9429L7.6 12L6.65711 11.0571L11.0571 6.65713L12 7.6L12.9429 6.65708L17.3429 11.0571L16.3999 12L17.3429 12.9429L12.9429 17.3429Z"
        fill={props.color}
      />
    </svg>
  );
}

Area.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Area.defaultProps = {
  color: '#202020',
  width: 24,
};